import {
  PointCloudStylingBand,
  PointCloudStylingClearance,
  PointCloudStylingUOM,
} from '@trimble/types';

export const POINT_CLOUD_CLEARANCE_DEFAULTS: Required<PointCloudStylingClearance> =
  {
    bands: [
      { start: -0.4, color: '#ff0000' },
      { start: 0, color: '#ff7f00' },
      { start: 0.1, color: '#ffff00' },
      { start: 0.2, color: '#00ff00' },
      { start: 0.3, color: '#0000ff' },
      { start: 0.4, color: '#000000' }, // Last color value is ignored
    ],
    defaultColor: '#C8A2C8',
    defaultTransparent: false,
  };

export interface PointCloudClearanceControlProps
  extends Partial<PointCloudStylingClearance> {
  uom: PointCloudStylingUOM;
  onBandsChange?(bands: PointCloudStylingBand[]): void;
  onDefaultColorChange?(defaultColor: string): void;
  onDefaultTransparentChange?(defaultTransparent: boolean): void;
}
